import {System} from '../../index.js';

/**
 * Creates Hypercube.js input systems.
 * @example
 * const systeminput = new SystemInput();
 *
 * // called by an update loop
 * systeminput.tick();
 */
class SystemInput extends System {

    /**
     * Stores the input events.
     * @type {Event[]}
     * @private
     */
    $events;

    /**
     * Creates a new Hypercube.js input system.
     */
    constructor() {

        super();

        this.$events = [];
    }

    /**
     * Stacks the input events for the next tick.
     * @param {Event} $event The input event to stack.
     * @private
     */
    $stack($event) {

        // @TODO : uncomment
        $event.preventDefault();

        this.$events.push($event);
    }

    /**
     * Destroys the system.
     * @public
     */
    destroy() {

        if (typeof this.engine.deviceviewer !== 'undefined') {

            this.engine.deviceviewer.element.removeEventListener('blur', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('contextmenu', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('pointerdown', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('pointerenter', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('pointerleave', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('pointermove', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('pointerup', this.$stack.bind(this));
            this.engine.deviceviewer.element.removeEventListener('wheel', this.$stack.bind(this));
        }

        document.removeEventListener('keydown', this.$stack.bind(this));
        document.removeEventListener('keyup', this.$stack.bind(this));
    }

    /**
     * Starts the system.
     * @public
     */
    start() {

        // @TODO : treat keyboard/gamepad/... events from top to bottom
        // @TODO : treat pointer events on target (then delegate or bubble in cb)

        if (typeof this.engine.deviceviewer !== 'undefined') {

            // @TODO : tout dépend de deviceviewer ???
            // @TODO : créer deviceinput ???
            this.engine.deviceviewer.element.addEventListener('blur', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('contextmenu', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('pointerdown', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('pointerenter', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('pointerleave', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('pointermove', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('pointerup', this.$stack.bind(this));
            this.engine.deviceviewer.element.addEventListener('wheel', this.$stack.bind(this));
        }

        document.addEventListener('keydown', this.$stack.bind(this));
        document.addEventListener('keyup', this.$stack.bind(this));
    }

    /**
     * Updates the system once.
     * @param {number} $timeframe The timeframe duration (in ms).
     * @public
     */
    tick($timeframe) {

        while (this.$events.length > 0) {

            const event = this.$events.shift();

            this.scene.getnodeswithscript(this.scene.noderoot).forEach(($node) => {

                $node.script.oninput($node, event);
            });
        }
    }
}

export {

    SystemInput
};

export default SystemInput;
